/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetInsightUserAccessParams,
  InsightUserDto,
  InsightUserRequest,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns all client users with metadata</br></br>Authorities: **Any authenticated role**
 */
export const getInsightUserAccess = (
  userId: string,
  insightId: number,
  params?: GetInsightUserAccessParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightUserDto[]>(
    {
      url: `/api/${userId}/insights/${insightId}/users`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getGetInsightUserAccessQueryKey = (
  userId: string,
  insightId: number,
  params?: GetInsightUserAccessParams
) => {
  return [
    `/api/${userId}/insights/${insightId}/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetInsightUserAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof getInsightUserAccess>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightUserAccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightUserAccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInsightUserAccessQueryKey(userId, insightId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInsightUserAccess>>
  > = ({ signal }) =>
    getInsightUserAccess(userId, insightId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && insightId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInsightUserAccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetInsightUserAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInsightUserAccess>>
>;
export type GetInsightUserAccessQueryError = ErrorType<unknown>;

export function useGetInsightUserAccess<
  TData = Awaited<ReturnType<typeof getInsightUserAccess>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params: undefined | GetInsightUserAccessParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightUserAccess>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightUserAccess>>,
          TError,
          Awaited<ReturnType<typeof getInsightUserAccess>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsightUserAccess<
  TData = Awaited<ReturnType<typeof getInsightUserAccess>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightUserAccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightUserAccess>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsightUserAccess>>,
          TError,
          Awaited<ReturnType<typeof getInsightUserAccess>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetInsightUserAccess<
  TData = Awaited<ReturnType<typeof getInsightUserAccess>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightUserAccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightUserAccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetInsightUserAccess<
  TData = Awaited<ReturnType<typeof getInsightUserAccess>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  insightId: number,
  params?: GetInsightUserAccessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInsightUserAccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetInsightUserAccessQueryOptions(
    userId,
    insightId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateInsightClientUserAccess = (
  userId: string,
  insightId: number,
  insightUserRequest: BodyType<InsightUserRequest[]>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<InsightUserDto[]>(
    {
      url: `/api/${userId}/insights/${insightId}/users`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: insightUserRequest,
      signal,
    },
    options
  );
};

export const getUpdateInsightClientUserAccessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInsightClientUserAccess>>,
    TError,
    { userId: string; insightId: number; data: BodyType<InsightUserRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInsightClientUserAccess>>,
  TError,
  { userId: string; insightId: number; data: BodyType<InsightUserRequest[]> },
  TContext
> => {
  const mutationKey = ['updateInsightClientUserAccess'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInsightClientUserAccess>>,
    { userId: string; insightId: number; data: BodyType<InsightUserRequest[]> }
  > = (props) => {
    const { userId, insightId, data } = props ?? {};

    return updateInsightClientUserAccess(
      userId,
      insightId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInsightClientUserAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInsightClientUserAccess>>
>;
export type UpdateInsightClientUserAccessMutationBody = BodyType<
  InsightUserRequest[]
>;
export type UpdateInsightClientUserAccessMutationError = ErrorType<unknown>;

export const useUpdateInsightClientUserAccess = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateInsightClientUserAccess>>,
      TError,
      {
        userId: string;
        insightId: number;
        data: BodyType<InsightUserRequest[]>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateInsightClientUserAccess>>,
  TError,
  { userId: string; insightId: number; data: BodyType<InsightUserRequest[]> },
  TContext
> => {
  return useMutation(
    getUpdateInsightClientUserAccessMutationOptions(options),
    queryClient
  );
};
